import { inject, Injectable } from '@angular/core';
import { RootServicesModule } from './root-services.module';
import { HttpClient } from '@angular/common/http';
import { IFilter } from '../interfaces/filter-interfaces';
import { environment } from '@app-environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TinyHelper } from '../../shared/helper/tiny-helper';

@Injectable({
    providedIn: RootServicesModule
})
export class FilterService {
    private readonly http = inject(HttpClient);

    public getAllFilter(): Observable<IFilter> {
        return this.http.get<IFilter>(`${environment.gatewayAPI}/search/filters`).pipe(
            map((result) => ({
                ...result,
                formats: this.bundleFormats(result.formats).filter(TinyHelper.unique)
            }))
        );
    }

    private bundleFormats(formats: string[]): string[] {
        return formats
            .map((format) => {
                switch (format.toLowerCase()) {
                    case 'xls':
                    case 'xlt':
                    case 'xla':
                    case 'xlsx':
                    case 'xltx':
                    case 'xlsm':
                    case 'xltm':
                    case 'xlam':
                    case 'xlsb':
                        return 'Excel Table';
                    case 'doc':
                    case 'docx':
                    case 'dot':
                    case 'dotx':
                    case 'docm':
                    case 'dotm':
                        return 'Document';
                    case 'ppt':
                    case 'pot':
                    case 'potx':
                    case 'pps':
                    case 'ppa':
                    case 'pptx':
                    case 'ppsx':
                    case 'ppam':
                    case 'pptm':
                    case 'potm':
                    case 'ppsm':
                        return 'Power Point';
                    case 'pdf':
                        return 'PDF';
                    case 'txt':
                        return 'Text File';
                    case 'zip':
                    case '7z':
                        return 'Zip-Archive';
                    case 'htm':
                    case 'html':
                        return 'HTM File';
                    default:
                        return null;
                }
            })
            .filter((type) => !!type);
    }
}
